(function () {
  'use strict';

  const CFG = {
    DELAY_MS:       3000,
    STORAGE_KEY:    'fvp_closed',
    SUPPRESS_HOURS: 24,
  };

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);

  const State = {
    isSuppressed() {
      try {
        const raw = localStorage.getItem(CFG.STORAGE_KEY);
        if (!raw) return false;
        const { ts } = JSON.parse(raw);
        return (Date.now() - ts) < CFG.SUPPRESS_HOURS * 36e5;
      } catch { return false; }
    },
    suppress() {
      try { localStorage.setItem(CFG.STORAGE_KEY, JSON.stringify({ ts: Date.now() })); }
      catch {}
    }
  };

  class FloatingVideoPopup {
    constructor(root) {
      this.root      = root;
      this.isOpen    = false;
      this.lightboxOpen = false;
      this.videoUrl  = root.dataset.videoUrl;
      this.ctaUrl    = root.dataset.ctaUrl;
      this.ctaText   = root.dataset.ctaText;

      if (!this.videoUrl) {
        console.warn('FVP: No video URL found');
        return;
      }

      this.elCard        = $('[data-fvp="card"]', root);
      this.elVideo       = $('[data-fvp="video"]', root);
      this.elPoster      = $('[data-fvp="poster"]', root);
      this.elSpinner     = $('[data-fvp="spinner"]', root);
      this.elCloseBtn    = $('[data-fvp="close"]', root);
      this.elMuteBtn     = $('[data-fvp="mute"]', root);
      this.elPlayBtn     = $('[data-fvp="play-btn"]', root);
      this.elProgressBar = $('[data-fvp="progress-bar"]', root);
      this.elMuteIconOn  = this.elMuteBtn?.querySelector('.fvp-icon--unmuted');
      this.elMuteIconOff = this.elMuteBtn?.querySelector('.fvp-icon--muted');

      this._buildLightbox();
      this._bindEvents();
      this._scheduleOpen();
    }

    _buildLightbox() {
      const lb = document.createElement('div');
      lb.className = 'fvp-lightbox';
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('hidden', '');
      lb.innerHTML = `
        <div class="fvp-lb__backdrop"></div>
        <div class="fvp-lb__wrap">
          <button class="fvp-lb__close" aria-label="Close">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
              <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
            </svg>
          </button>
          <div class="fvp-lb__stage">
            <video class="fvp-lb__video" playsinline loop muted preload="none"></video>
            <div class="fvp-lb__spinner" aria-hidden="true"><div class="fvp-lb__ring"></div></div>
            <div class="fvp-lb__progress"><div class="fvp-lb__bar"></div></div>
            <div class="fvp-lb__controls">
              <button class="fvp-lb__mute" aria-label="Toggle mute">
                <svg class="fvp-lbicon--unmuted" width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M11 5L6 9H2v6h4l5 4V5z" fill="currentColor"/>
                  <path d="M19.07 4.93a10 10 0 010 14.14M15.54 8.46a5 5 0 010 7.07" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                </svg>
                <svg class="fvp-lbicon--muted" width="16" height="16" viewBox="0 0 24 24" fill="none" style="display:none">
                  <path d="M11 5L6 9H2v6h4l5 4V5z" fill="currentColor"/>
                  <line x1="23" y1="9" x2="17" y2="15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                  <line x1="17" y1="9" x2="23" y2="15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                </svg>
              </button>
        



              <a class="fvp-lb__cta" 
   href="${this.ctaUrl || '#'}" 
   onclick="event.preventDefault(); event.stopPropagation();">
  <span>${this.ctaText || 'Shop Now'}</span>
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</a>
            </div>
          </div>
        </div>
      `;

      document.body.appendChild(lb);
      this.elLightbox   = lb;
      this.elLbVideo    = lb.querySelector('.fvp-lb__video');
      this.elLbClose    = lb.querySelector('.fvp-lb__close');
      this.elLbBackdrop = lb.querySelector('.fvp-lb__backdrop');
      this.elLbSpinner  = lb.querySelector('.fvp-lb__spinner');
      this.elLbBar      = lb.querySelector('.fvp-lb__bar');
      this.elLbMuteBtn  = lb.querySelector('.fvp-lb__mute');
      this.elLbMuteOn   = lb.querySelector('.fvp-lbicon--unmuted');
      this.elLbMuteOff  = lb.querySelector('.fvp-lbicon--muted');
    }

    _bindEvents() {
      on(this.elCloseBtn, 'click', (e) => { e.stopPropagation(); this.close(); });
      on(this.elMuteBtn,  'click', (e) => { e.stopPropagation(); this.toggleMute(); });
      on(this.elCard, 'click', (e) => {
        if (e.target.closest('[data-fvp="close"]') || e.target.closest('[data-fvp="mute"]')) return;
        this.openLightbox();
      });
      on(this.elPlayBtn, 'click', (e) => { e.stopPropagation(); this.openLightbox(); });
      on(this.elLbClose,    'click', () => this.closeLightbox());
      on(this.elLbBackdrop, 'click', () => this.closeLightbox());
      on(this.elLbMuteBtn,  'click', () => this._lbToggleMute());
      on(this.elLbVideo, 'waiting',    () => this._lbSetLoading(true));
      on(this.elLbVideo, 'canplay',    () => this._lbSetLoading(false));
      on(this.elLbVideo, 'playing',    () => this._lbSetLoading(false));
      on(this.elLbVideo, 'timeupdate', () => this._lbTimeUpdate());
      on(this.elLbVideo, 'error',      () => this._lbSetLoading(false));
      on(document, 'keydown', (e) => { if (e.key === 'Escape' && this.lightboxOpen) this.closeLightbox(); });
    }

    _scheduleOpen() {
      if (State.isSuppressed()) return;
      this.root.classList.remove('fvp-hidden');
      setTimeout(() => this._openCard(), CFG.DELAY_MS);
    }

    _openCard() {
      if (this.isOpen) return;
      this.isOpen = true;
      requestAnimationFrame(() => {
        this.elCard?.classList.add('fvp--visible');
      });
    }

    openLightbox() {
      if (this.lightboxOpen) return;
      this.lightboxOpen = true;
      this.elCard?.classList.add('fvp--lb-open');

      const v = this.elLbVideo;
      v.muted = true;
      v.setAttribute('playsinline', '');
      if (!v.src) {
        v.src = this.videoUrl;
        this._lbSetLoading(true);
        v.load();
      }

      this.elLightbox.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';

      requestAnimationFrame(() => {
        this.elLightbox.classList.add('fvp-lb--visible');
        v.play().catch(err => {
          console.warn('FVP lightbox play failed:', err.message);
          this._lbSetLoading(false);
        });
      });
    }

    closeLightbox() {
      if (!this.lightboxOpen) return;
      this.lightboxOpen = false;
      this.elLbVideo?.pause();
      this.elLightbox.classList.remove('fvp-lb--visible');
      this.elCard?.classList.remove('fvp--lb-open');
      document.body.style.overflow = '';
      setTimeout(() => { this.elLightbox.setAttribute('hidden', ''); }, 350);
    }

    _lbSetLoading(active) {
      this.elLbSpinner?.classList.toggle('fvp--active', active);
    }

    _lbTimeUpdate() {
      const v = this.elLbVideo;
      if (!v || !v.duration || !this.elLbBar) return;
      this.elLbBar.style.width = `${(v.currentTime / v.duration) * 100}%`;
    }

    _lbToggleMute() {
      const v = this.elLbVideo;
      if (!v) return;
      const muted = !v.muted;
      v.muted = muted;
      if (this.elLbMuteOn)  this.elLbMuteOn.style.display  = muted ? 'none' : '';
      if (this.elLbMuteOff) this.elLbMuteOff.style.display = muted ? ''     : 'none';
    }

    close() {
      this.closeLightbox();
      this.isOpen = false;
      this.elVideo?.pause();
      this.elCard?.classList.remove('fvp--visible');
      this.root.classList.add('fvp-hidden');
      setTimeout(() => { this.root.setAttribute('hidden', ''); }, 420);
      State.suppress();
    }

    toggleMute() {
      if (!this.elVideo) return;
      const muted = !this.elVideo.muted;
      this.elVideo.muted = muted;
      if (this.elMuteIconOn)  this.elMuteIconOn.style.display  = muted ? 'none' : '';
      if (this.elMuteIconOff) this.elMuteIconOff.style.display = muted ? ''     : 'none';
    }
  }

  function init() {
    const root = document.getElementById('fvp-root');
    if (!root) { setTimeout(init, 300); return; }
    window.__fvp_instance__ = new FloatingVideoPopup(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.FVP = {
    open:         () => window.__fvp_instance__?._openCard(),
    openLightbox: () => window.__fvp_instance__?.openLightbox(),
    close:        () => window.__fvp_instance__?.close(),
    reset:        () => localStorage.removeItem('fvp_closed'),
  };

})();